module.exports = __webpack_public_path__ + "static/media/emotion.f72af37f.png";